import type { Session } from "@webyonetim/contracts";

import { Button } from "../../components/ui/Controls";
import { StatusBadge } from "../../components/ui/Feedback";
import { ResponsiveData, type DataColumn } from "../../components/ui/ResponsiveData";
import { formatDateTime } from "../../lib/format";

export function SessionList({
  onRevoke,
  sessions,
}: {
  readonly onRevoke: (session: Session) => void;
  readonly sessions: readonly Session[];
}) {
  const sorted = [...sessions].sort(
    (left, right) =>
      Number(right.current) - Number(left.current) ||
      new Date(right.lastActiveAt).getTime() - new Date(left.lastActiveAt).getTime(),
  );
  const columns: readonly DataColumn<Session>[] = [
    {
      header: "Cihaz ve tarayıcı",
      key: "device",
      render: (session) => (
        <>
          <strong>{session.deviceLabel}</strong>
          {session.current ? (
            <>
              <br />
              <StatusBadge label="Bu oturum" status="active" />
            </>
          ) : null}
        </>
      ),
    },
    { header: "IP", key: "ip", render: (session) => session.ipAddress ?? "IP bilgisi yok" },
    {
      header: "Oluşturulma",
      key: "created",
      render: (session) => (
        <time dateTime={session.createdAt}>{formatDateTime(session.createdAt)}</time>
      ),
    },
    {
      header: "Son etkinlik",
      key: "active",
      render: (session) => (
        <time dateTime={session.lastActiveAt}>{formatDateTime(session.lastActiveAt)}</time>
      ),
    },
    {
      header: "Sona erme",
      key: "expires",
      render: (session) => (
        <time dateTime={session.expiresAt}>{formatDateTime(session.expiresAt)}</time>
      ),
    },
    {
      header: "Durum",
      key: "status",
      render: (session) => (
        <StatusBadge
          label={
            session.status === "active"
              ? "Etkin"
              : session.status === "expired"
                ? "Süresi doldu"
                : "Sonlandırıldı"
          }
          status={
            session.status === "active"
              ? "active"
              : session.status === "expired"
                ? "expired"
                : "revoked"
          }
        />
      ),
    },
    {
      header: "İşlemler",
      key: "actions",
      render: (session) =>
        session.current ? (
          <span className="muted">Çıkış yap ile sonlandırılır</span>
        ) : session.status === "active" ? (
          <Button
            onClick={() => {
              onRevoke(session);
            }}
            variant="destructive"
          >
            Oturumu sonlandır
          </Button>
        ) : (
          <span className="muted">İşlem yok</span>
        ),
    },
  ];
  return (
    <ResponsiveData
      caption="Hesap oturumları"
      columns={columns}
      getKey={(session) => session.id}
      items={sorted}
      mobileHeading={(session) => session.deviceLabel}
    />
  );
}
